import { Form, Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../../services/auth";
import { useDispatch } from "react-redux";
import { setUser } from "../../../redux/slices/user";
import { AppDispatch } from "../../../redux/store";
import BrandMark from "../../brand-mark";

const LoginForm = () => {
  const [login, { isLoading }] = useLoginMutation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values: any) => {
    try {
      const response = await login(values).unwrap();
      localStorage.setItem("accessToken", response.accessToken);
      localStorage.setItem("refreshToken", response.refreshToken);
      dispatch(
        setUser({
          user_name: response.user.user_name,
          email: response.user.email,
          role: response.user.user_role,
          _id: response.user._id,
        })
      );
      const userData = {
        user_name: response.user.user_name,
        email: response.user.email,
        role: response.user.user_role,
        _id: response.user._id,
      };
      localStorage.setItem("user", JSON.stringify(userData));
      messageApi.success("Đăng nhập thành công");
      navigate("/device_management");
    } catch (error) {
      console.error("Login failed:", error);
      messageApi.error("Sai tên tài khoản hoặc mật khẩu");
    }
  };

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center", padding: "20px" }}>
      {contextHolder}
      <div className="login-card">
        <BrandMark variant="login" />

        <Form
          name="login"
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="Tên đăng nhập"
            name="username"
            rules={[
              { required: true, message: "Vui lòng nhập tên đăng nhập!" },
            ]}
          >
            <Input placeholder="Nhập tên đăng nhập" />
          </Form.Item>

          <Form.Item
            label="Mật khẩu"
            name="password"
            rules={[{ required: true, message: "Vui lòng nhập mật khẩu!" }]}
          >
            <Input.Password placeholder="Nhập mật khẩu" />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" block loading={isLoading}>
              Đăng nhập
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;
